"use strict";
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
import "../util/fetch";
import { factorInIndexerMode, isIndexerMode } from "./index_audit_split_mode";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
export const UPDATE_DOCUMENT_GROUPS_TIMEOUT_MS = 12e4;
const DocumentIndexerService = function(documentBatch, DataStoreService, accountApi, propsLocation, propsHistory) {
  const allDocumentsGroupedStep = function() {
    if (accountApi.hasRole("Factor")) {
      if (isIndexerMode(propsLocation)) {
        return "assignDebtor";
      } else {
        return "extractData";
      }
    } else {
      return "assignLoads";
    }
  };
  const service = {
    documentBatch,
    steps: [
      "assignCarrier",
      "assignTypes",
      "assignGroups",
      allDocumentsGroupedStep(),
      factorInIndexerMode(propsLocation) ? "review" : null
    ].filter((s) => s != null),
    step: "assignCarrier",
    stepNumber() {
      return this.steps.indexOf(this.step);
    },
    stepNumberForName(stepName) {
      return this.steps.indexOf(stepName);
    },
    updateDocumentGroups(documentBatchId) {
      return ApiService.addErrorHandler(
        // TODO: use fetch instead
        // eslint-disable-next-line no-restricted-syntax
        $.ajax({
          url: `/api/document_groups/${documentBatchId}`,
          type: "PUT",
          contentType: "application/json",
          timeout: UPDATE_DOCUMENT_GROUPS_TIMEOUT_MS
        }).then((data) => {
          if (data && data.redirect_to_dashboard) {
            ToDashboardWithFilters(propsLocation, propsHistory);
            return Promise.reject({ redirected: true });
          }
          const r = DataStoreService.updateStores(data);
          this.updateStep();
          return r.document_batch;
        }),
        "The document groups did not save, please try again.",
        { caller: "DocumentIndexerService.updateDocumentGroups" }
      );
    },
    clearGroupingErrors(documentIds) {
      return $.post("/api/documents/clear_grouping_errors", {
        document_ids: documentIds
      }).then((data) => {
        const r = DataStoreService.updateStores(data);
        this.updateStep();
        return r.document_batch;
      });
    },
    currentGuessedLoads(group, includeRelated) {
      const ids = this.currentLoadIds(group.documents);
      const selectedLoadIds = _.uniq(this.selectedLoadIds(group.documents));
      const data = {
        carrier_id: documentBatch.carrier_id,
        load_ids: ids,
        load_state_ids: selectedLoadIds,
        include_related: includeRelated,
        group_id: group.id
      };
      return ApiService.addErrorHandler(
        // TODO: use fetch instead
        // eslint-disable-next-line no-restricted-syntax
        $.ajax({
          url: "/api/load_searches/by_load_id",
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(data)
        }).then((data2) => {
          if (data2 && data2.related) {
            DataStoreService.responseHandler(data2.related);
          }
          return data2;
        }, _.identity),
        null,
        { caller: "DocumentIndexerService.currentGuessedLoads" }
      );
    },
    selectedLoadIds(documents) {
      return _.flatten(
        _.compact(_.pluck(_.pluck(documents, "data"), "load_state_ids"))
      );
    },
    currentLoadIds(documents) {
      return _.chain(documents).pluck("pages").flatten().pluck("load_ids").flatten().compact().value();
    },
    updateDocumentException(message, exception, documentGroup) {
      const data = { resolution: message };
      return this._updateException(data, documentGroup, exception, "", "PUT");
    },
    resolveDocumentException(exception, documentGroup) {
      const data = { ignore: documentGroup.ignored };
      return this._updateException(
        data,
        documentGroup,
        exception,
        "/resolve",
        "POST"
      );
    },
    _updateException(data, documentGroup, exception, action, type) {
      return $.ajax({
        url: `/api/document_groups/${documentGroup.id}/exceptions/${exception.id}${action}`,
        type,
        contentType: "application/json",
        data: JSON.stringify(data)
      }).then(DataStoreService.responseHandler, _.identity);
    },
    saveDocumentException(message, documentGroup, ignore) {
      const exception = { message, ignore };
      return $.ajax({
        url: `/api/document_groups/${documentGroup.id}/exceptions`,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(exception)
      }).then(DataStoreService.responseHandler, _.identity);
    },
    searchForLoads(terms) {
      return $.get("/api/load_searches/by_location", terms).then(
        DataStoreService.responseHandler,
        _.identity
      );
    },
    _initialize() {
      this.updateStep();
    },
    _allDocumentsHaveTypes() {
      return _.all(documentBatch.documents, (d) => {
        return d.type;
      });
    },
    _hiddenDocumentsExist() {
      return _.some(documentBatch.documents, (d) => {
        return d.hidden;
      });
    },
    _allDocumentsHaveGroups() {
      return _.all(documentBatch.documents, (d) => {
        return d.data && d.data.group_id;
      });
    },
    _allFactorInvoicesHaveDebtorSelection() {
      return _.all(documentBatch.factor_invoices, (i) => {
        return i.factor_broker_id || i.data["no_debtor_selected"];
      });
    },
    _groupingErrorsExist() {
      return _.some(documentBatch.documents, (d) => {
        return (d.data["grouping_errors"] || []).length > 0;
      });
    },
    updateStep() {
      if (!_.isNull(documentBatch.single_carrier)) {
        if (this._allDocumentsHaveTypes()) {
          if (this._groupingErrorsExist()) {
            this.step = "assignTypes";
          } else if (this._allDocumentsHaveGroups()) {
            if (factorInIndexerMode(propsLocation) && this._allFactorInvoicesHaveDebtorSelection()) {
              this.step = "review";
            } else {
              this.step = allDocumentsGroupedStep();
            }
          } else {
            if (!documentBatch.attempted_to_auto_group) {
              this.step = "assignTypes";
            } else {
              this.step = "assignGroups";
            }
          }
        } else {
          this.step = "assignTypes";
        }
      } else {
        this.step = "assignCarrier";
      }
    }
  };
  service._initialize();
  return service;
};
export default DocumentIndexerService;
